import { Controller } from "@hotwired/stimulus"

// Auto-descarte de los avisos de éxito (feedback UI: el "Traspaso eliminado."
// se quedaba en pantalla hasta refrescar la página). Solo lo lleva la clase
// notice/success — en _notices.slim; los errores se quedan, pueden pedir
// acción del usuario.
//
// La salida es un fundido (.tp-flash--leaving, _flash.scss) y el elemento se
// remueve por TIMER, no por transitionend: si un morph de Turbo re-renderiza
// a mitad del fundido y restaura las clases del HTML servido, la remoción
// ocurre igual.
export default class extends Controller {
  static values = { dismissAfter: { type: Number, default: 6000 } }

  connect() {
    this.hideTimer = setTimeout(() => this.dismiss(), this.dismissAfterValue)
  }

  disconnect() {
    clearTimeout(this.hideTimer)
    clearTimeout(this.removeTimer)
  }

  dismiss() {
    this.element.classList.add("tp-flash--leaving")
    this.removeTimer = setTimeout(() => this.element.remove(), 300)
  }
}
